module.exports = __webpack_public_path__ + "static/media/S (75).bb2dc8c5.jpg";